import { THREE_D_VARIANTS } from './threeDVariants';

const MISC_VARIANTS = [
    { id: 'sparkline', label: 'Sparkline', icon: 'fas fa-signature', title: 'kWh Trend', layout: { w: 3, h: 3, minW: 2, minH: 2 } },
    { id: 'comparison', label: 'Comparison', icon: 'fas fa-balance-scale', title: 'Energy Comparison', layout: { w: 3, h: 3, minW: 3, minH: 2 } },
    { id: 'clock', label: 'Live Clock', icon: 'fas fa-clock', title: 'Site Time', layout: { w: 3, h: 3, minW: 2, minH: 2 } },
    { id: 'note', label: 'Note', icon: 'fas fa-sticky-note', title: 'Notes', layout: { w: 6, h: 4, minW: 3, minH: 3 } },
    { id: 'alert-feed', label: 'Alert Feed', icon: 'fas fa-bell', title: 'Recent Alerts', layout: { w: 6, h: 4, minW: 3, minH: 3 } },
    { id: 'kpi-grid', label: 'KPI Grid', icon: 'fas fa-table-cells', title: 'KPI Summary', layout: { w: 4, h: 4, minW: 3, minH: 3 } },
    { id: 'energy-flow', label: 'Energy Flow', icon: 'fas fa-random', title: 'Power Flow', layout: { w: 6, h: 3, minW: 4, minH: 2 } },
    { id: 'weather', label: 'Weather', icon: 'fas fa-cloud-sun', title: 'Site Conditions', layout: { w: 3, h: 3, minW: 2, minH: 2 } },
    { id: 'maintenance-tickets', label: 'Maintenance Tickets', icon: 'fas fa-ticket', title: 'Maintenance Tickets', layout: { w: 4, h: 4, minW: 3, minH: 3 } },
    { id: 'leaderboard', label: 'Top Consumers', icon: 'fas fa-ranking-star', title: 'Top Consumers', layout: { w: 4, h: 4, minW: 3, minH: 3 } },
    { id: 'health-score', label: 'Health Score', icon: 'fas fa-heart-pulse', title: 'Equipment Health', layout: { w: 4, h: 3, minW: 3, minH: 3 } },
];

const THREE_D_WITH_LAYOUT = THREE_D_VARIANTS.map((v) => ({
    ...v,
    title: v.label,
    layout: { w: 3, h: 4, minW: 3, minH: 3 },
}));

export const EXTRA_VARIANTS = [...MISC_VARIANTS, ...THREE_D_WITH_LAYOUT];

export const THREE_D_IDS = THREE_D_VARIANTS.map((v) => v.id);
